import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { PreferenceProvider } from "./PreferenceProvider";
import { PreferencesList } from "./PreferencesList";

export const PreferencePage: FC = () => {
	return (
		<Routes>
			<Route
				index
				element={
					<PreferenceProvider>
						<PreferencesList />
					</PreferenceProvider>
				}
			/>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
